import React from 'react'

import {
  EnterpriseInitiativeLoaderAction,
  setEnterpriseInitiativeInfo,
  setIsLoadingEnterpriseInitiativeInfo
} from './store/Actions'
import { EnterpriseRequests } from 'lib'

export default class EnterpriseInitiativeLoaderService {
  static async loadEnterpriseInitiativeInfo(
    dispatch: React.Dispatch<EnterpriseInitiativeLoaderAction>,
    enterpriseId: string,
    submissionLinkCode: string,
    email: string,
    onError: (error: string) => void
  ) {
    dispatch(setIsLoadingEnterpriseInitiativeInfo(true))

    const [data, , error] = await EnterpriseRequests.validateSubmissionLink(enterpriseId, submissionLinkCode, email)

    dispatch(setIsLoadingEnterpriseInitiativeInfo(false))

    if (error) {
      onError(error)
      return
    }

    dispatch(setEnterpriseInitiativeInfo(data))
  }
}
